import { Cookies, getCookieConsentValue } from 'react-cookie-consent'

declare global {
    interface Window {
        dataLayer: unknown[]
        gtag: (...args: unknown[]) => void
    }
}

type RouteLocation = Pick<Location, 'pathname' | 'search' | 'hash'>

export const CONSENT_COOKIE = 'gatsby-gdpr-google-tagmanager'
export const CONSENT_EXPIRY_DAYS = 365
export const COOKIE_SETTINGS_ANCHOR = 'cookie-settings'

const GTM_ID = 'GTM-WWNTBQTD'
const ROUTE_CHANGE_EVENT = 'gatsbyRouteChange'
const ANALYTICS_COOKIE_PATTERN = /^(_ga|_gid|_gat|_gcl)/

let isGtmLoaded = false

export const hasAnalyticsConsent = (): boolean => getCookieConsentValue(CONSENT_COOKIE) === 'true'

const isGoogleTagManagerEnabled = (): boolean => !!process.env.GATSBY_FLAG_ENABLE_GOOGLE_TAG_MANAGER

export const isGoogleTagManagerLoaded = (): boolean => isGtmLoaded

const loadGoogleTagManager = (): void => {
    if (isGtmLoaded) return

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
    document.head.appendChild(script)

    window.gtag = function gtag() {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments)
    }
    window.gtag('js', new Date())

    isGtmLoaded = true
}

const trackRouteChange = (location: RouteLocation): void => {
    if (!isGtmLoaded) return

    window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search + location.hash,
    })
    setTimeout(() => window.dataLayer.push({ event: ROUTE_CHANGE_EVENT }), 50)
}

export const startGoogleTagManager = (location: RouteLocation): void => {
    if (!isGoogleTagManagerEnabled()) return

    loadGoogleTagManager()
    trackRouteChange(location)
}

const getCookieDomains = (): (string | undefined)[] => {
    const labels = window.location.hostname.split('.')
    const parentDomains = labels.slice(0, -1).map((_, index) => `.${labels.slice(index).join('.')}`)

    return [undefined, ...parentDomains]
}

export const clearAnalyticsCookies = (): void => {
    const analyticsCookies = Object.keys(Cookies.get()).filter((name) =>
        ANALYTICS_COOKIE_PATTERN.test(name),
    )
    if (analyticsCookies.length === 0) return

    const domains = getCookieDomains()
    analyticsCookies.forEach((name) =>
        domains.forEach((domain) => Cookies.remove(name, { path: '/', domain })),
    )
}
